import { createZustandShallowStore } from '@/lib/zustand';
import { DossierNotificationResponse } from '@/server/api/v1/dossier-notification/type';
import { AppNotificationResponse } from '@/server/api/v1/notification/type';
import { SetStoreState } from '@/types/use';

export type NotifcationStoreProps<T> = {
    arrNotice: T[];
    totalNotification: number;
    totalUnRead: number;

    pageNumber: number;
    totalPage: number;

    setStoreState: SetStoreState<Partial<NotifcationStoreProps<T>> | undefined>;
};

/**save state of header-dropdown-notifaiction */
export const useHeaderNotificationDropdownStore = createZustandShallowStore<{
    open: boolean;
    setOpen: SetStoreState<boolean>;

    /**header noticenotice của customer */
    isCustomer: boolean;
    setIsCustomer: SetStoreState<boolean>;
}>((set, get) => {
    return {
        open: false,
        setOpen: (fn) => {
            set((st) => {
                return {
                    open: typeof fn === 'function' ? fn(st.open) : fn,
                };
            });
        },
        isCustomer: false,
        setIsCustomer: (fn) => {
            set((st) => {
                return {
                    isCustomer:
                        typeof fn === 'function' ? fn(st.isCustomer) : fn,
                };
            });
        },
    };
});

/**Store lưu trữ thông báo chung */
export const useAppNotificationStore = createZustandShallowStore<
    NotifcationStoreProps<AppNotificationResponse>
>((set, get) => {
    return {
        arrNotice: [],
        totalNotification: 0,
        totalUnRead: 0,

        totalPage: 0,
        pageNumber: 1,

        setStoreState(fn) {
            set((st) => {
                const _obj = typeof fn === 'function' ? fn(st) : fn;
                return {
                    ..._obj,
                };
            });
        },
    };
});

/**Store lưu trữ thông báo hồ sơ */
export const useDossierNotificationStore = createZustandShallowStore<
    NotifcationStoreProps<DossierNotificationResponse>
>((set, get) => {
    return {
        arrNotice: [],
        totalNotification: 0,
        totalUnRead: 0,

        totalPage: 0,
        pageNumber: 1,

        setStoreState(fn) {
            set((st) => {
                const _obj = typeof fn === 'function' ? fn(st) : fn;
                return {
                    ..._obj,
                };
            });
        },
    };
});
